/**
 * Denis Callinan
 * Project Andromeda
 * August 1st, 2020
 * SectionHeader.js - Component for sections
 */

 // Core
import React from 'react'
import './SectionHeader.css'

export default function SectionHeader(props) {
    var styleA = {
        color: "white",
        textShadow: "0px 2px #2d3142",
        textAlign: "center"
    }
    var styleB = {
        color: "black",
        textAlign: "center"
    }
    return(
        <div class = "sectionHeader">
            <h3 style = {props.txt ? styleA: styleB}>{props.title}</h3>
            <div id = {props.sectionID}></div>
        </div>
    );
}